export const PAGES_HEAD_CONTENT = {
  MAIN: {
    title: "MobileMonkey | World's Best Messenger Marketing Platform",
    meta: {
      description: `
        With MobileMonkey, you can create chatbots for free without writing a single line of code.
        Your engagement rate is about to go bananas.
      `,
    },
  },
  LOGIN: {
    title: 'MobileMonkey Login',
    meta: {
      description: `
        Welcome back to MobileMonkey! Ready to build more chatbots?
        Log in to your account with your email address or your Facebook account.
      `,
    },
  },
  SIGNUP: {
    title: 'Sign Up for MobileMonkey',
    meta: {
      description: `
        Welcome to our coding-free chatbot builder!
        Sign up for a MobileMonkey account and start creating Facebook Messenger chatbots today.
      `,
    },
  },
  AUTOMATIONS: {
    title: 'MobileMonkey | Automations',
    meta: { description: 'MobileMonkey | Automations' },
  },
};

export default PAGES_HEAD_CONTENT;
